import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {ReportsAbstractService} from "./reports-abstract.service";

@Injectable()
export class ChargebackReportService extends ReportsAbstractService {
  reportRoute = 'chargeback_report'
  constructor(protected http: HttpClient) {
    super(http);
    this.route = this.reportRoute;
  }
}
